export default "__VITE_ASSET__DmcT0$Lm__"